export enum StorageType {
  // InternalAmazonS3 = "InternalAmazonS3",
  ExternalAmazonS3 = "ExternalAmazonS3",
  AzureBlob = "AzureBlob",
  GCPCloud = "GCPCloud",
}
